import React from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

const MultiSelectAll = ({ options, selectedOptions, callback, controlid }) => {
  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      // return `${placeholderButtonLabel}: All Selected`;
      return `All Selected`;
    } else if (value.length > 0 && value.length <= 3) {
      return `${value
        .slice(0, 3)
        .map((attribute) => attribute.label)
        .toString()}`;
    } else {
      // return `${placeholderButtonLabel}: ${value.length} selected`;
      return `${value.length} selected`;
    }
  }

  function onChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      this.setState({
        val: this.options,
        controlid: controlid,
      });
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      this.setState({
        val: [],
        controlid: controlid,
      });
    } else if (event.action === "deselect-option") {
      this.setState({
        val: value.filter((o) => o.value !== "*"),
        controlid: controlid,
      });
    } else if (value.length === this.options.length - 1) {
      this.setState({ val: this.options, controlid: controlid });
    } else {
      this.setState({ val: value, controlid: controlid });
    }
  }

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      border: "1px solid #CED4DA",
    }),
    dropdownButton: (provided, state) => ({
      ...provided,
      minWidth: "400px",
      maxWidth: "400px",
      // height: '50px',
      color: "#000",
      fontWeight: "400",
      fontSize: "0.875rem",
      marginRight: "20px",
      rounded: "4px",
      border: "1px solid #CED4DA",
    }),
    container: (provided, state) => ({
      ...provided,
      color: "#000",
      minWidth: "400px",
      marginRight: "30px",
      shadow: "none",
      border: "1px solid #CED4DA",
      height: "50px",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };
  return (
    <ReactMultiSelectCheckboxes
      options={options.length > 0 ? [{ label: "All Selected", value: "*" }, ...options]:[]}
      getDropdownButtonLabel={getDropdownButtonLabel}
      
      value={selectedOptions}
      onChange={onChange}
      setState={callback}
      styles={customStyles}
      isDisabled = {options.length === 0}
    />
  );
};

export default MultiSelectAll;
